import axios from 'axios';
import { getCookie } from '../util/index';
import { logout } from '../util/index'
import getLodash from 'lodash/get'
import {
  apiIDBCache,
} from '../services/apiIDBCache';

axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
const isLoginPage = document.getElementById('txtInputName');
if(!isLoginPage){
  axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
}
axios.defaults.method = 'post';

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return null;
}

function applyEditTransactionHeader() {
  const transactionId = getQueryVariable('shipmentHttpId') || getQueryVariable('transactionId');
  if (transactionId && String(transactionId).startsWith('KX-')) {
    axios.defaults.headers.common['editShipment'] = 'true';
  } else {
    delete axios.defaults.headers.common['editShipment'];
  }
}

applyEditTransactionHeader();

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  const msg = getLodash(error, 'response.data.msg', null)
  if (msg === 'Expired Token' || msg === 'Expired token' || msg === 'Event not allowed without valid token') {
    if(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken' && 
    (!window.localStorage.getItem("401Reloads") || parseInt(window.localStorage.getItem("401Reloads")) < 5)){
      window.localStorage.setItem("401Reloads", (parseInt(window.localStorage.getItem("401Reloads"))||0)+1)
      window.location.reload(true);
      return;
    }

    console.error('Expired Token: ', 'Expired Token');
    logout();
    if (window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken') {
      return;
    }
    setTimeout(()=>{
      window.location = '/'
    },0);
  }
  return Promise.reject(error);
});

const custom = async (config = {}) => {
  let eventType = config.data.eventType;
  axios.defaults.headers.common['kxToken']  = (['VALIDATE_AUTH_TOKEN','SET_AUTH_TOKEN'].includes(eventType)) ? "" : getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
  applyEditTransactionHeader();
  axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
  config.url = config.url || axios.defaults.baseURL + "?axd=" + config.data.eventType;
  if (eventType == "GENERATE_PDF" || eventType == "SUBMIT_ENTRY_SUMMARY_FORM" || eventType == "INITIALIZE_ENTRY_SUMMARY_FORM") {
    let chartoAdd = config.url.indexOf('?') >= 0 ? '&' : '?';
    config.url += `${chartoAdd}timeout=100000`
  }

  return apiIDBCache.wrapAxiosRequest(config, (cfg) => axios(cfg));
}

const fileUpload = (data, config = {}, shipId) => {
  const mediaUrl = `${window._env_.REACT_APP_MEDIA_URL}/${shipId}`;
  axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL;
  return axios({
    ...data,
    ...config,
    url: mediaUrl,
  });
}

const addDoc = (data, config = {}) => {
  const brokerApiUrl = window._env_.REACT_APP_BROKER_API_URL;
  axios.defaults.baseURL = brokerApiUrl;
  return axios({
    ...data,
    ...config,
    url: `${brokerApiUrl}?axd=${data.data.eventType}&timeout=35000`,
  });
}

const all = (requestArray) => {
  return axios.all(requestArray)
}
const post = data => {
  let config = {}
  config.data = data
  return axios(config)
}
const get = (url = '', data = '', config = {}) => {
  config.params = data;
  config.method = "get";
  return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del,
  all,
  fileUpload,
  addDoc,
}

export { HttpClient }
